import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 15,
    s: 0
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = current.h * 3600 + current.m * 60 + current.s;
        if (seconds <= 0) return current;
        const next = seconds - 1;
        return {
          h: Math.floor(next / 3600),
          m: Math.floor(next % 3600 / 60),
          s: next % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const formattedTime = `${String(timeLeft.h).padStart(2, '0')}:${String(timeLeft.m).padStart(2, '0')}:${String(timeLeft.s).padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full border-b border-emerald-300/70 bg-[#087A49] text-white shadow-[0_4px_14px_rgba(8,122,73,0.35)]" data-id="element-309" data-mp="1bveryb8d5j3g">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-3 py-1.5 text-[10px] font-semibold sm:gap-4 sm:text-xs" data-id="element-310" data-mp="1gurpbpwv28ka">
        <div className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-311" data-mp="22nzv0ekhhbt4">
          <span className="relative flex h-1.5 w-1.5" aria-hidden="true" data-id="element-312" data-mp="22motymifai5p">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#D8FF73] opacity-90" data-id="element-313" data-mp="1xpoly620j5by" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#D8FF73]" data-id="element-314" data-mp="1sremvkd63kl2" />
          </span>
          <strong className="uppercase tracking-[0.1em]" data-id="element-315" data-mp="2qcstahokvvqw">Oferta activa</strong>
        </div>
        <span className="h-3.5 w-px bg-white/35" aria-hidden="true" data-id="element-316" data-mp="2lf0vx855zhfb" />
        <div className="flex items-center gap-1 whitespace-nowrap text-white/90" data-id="element-317" data-mp="2ged3ci1aesiz">
          <ClockIcon className="h-3.5 w-3.5 text-[#D8FF73]" aria-hidden="true" data-id="element-318" data-mp="2cecf65odz2yq" />
          <span className="hidden sm:inline" data-id="element-319" data-mp="1509bpii69gh3">Precio especial termina en</span>
          <span className="font-mono font-bold tabular-nums text-[#D8FF73]" data-id="element-320" data-mp="14y4y28uh133m">{formattedTime}</span>
        </div>
        <a href="https://mega-pack-reiki.impultienda.ar/checkout" className="rounded-full bg-white px-2.5 py-1 text-[9px] font-extrabold tracking-[0.04em] text-[#07663D] shadow-sm transition-transform hover:scale-[1.03] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:px-3 sm:text-[10px]" data-id="element-321" data-mp="1110gsabebcjy">
          VER PACK →
        </a>
      </div>
    </div>;
}